import Results from "../Lookup/Results/Results";

export default function ResultsPage() {
  return (
    <div className="lookup">
      <h1>Property Search</h1>
      <Results />
    </div>
  );
}
